import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import PropTypes from 'prop-types'

import * as Herz from '@rushplay/herz'

import { NavigationLink, PageNavigation } from '../page-navigation'

const categories = [
  'discover',
  'roulette',
  'blackjack',
  'baccarat',
  'game-shows',
  'other',
]

const navigationItems = categories.map(category => {
  const type = category.toLowerCase()

  return {
    label: `live-casino.categories.${type}`,
    to: `/live-casino/${type}`,
  }
})

export function LiveCasinoNavigation(props) {
  const { category } = ReactRouter.useParams()
  const translate = Herz.I18n.useTranslate()

  React.useEffect(() => {
    props.onUpdateCategory(category)
  }, [category])

  return (
    <ReactRouter.Switch>
      <ReactRouter.Redirect
        exact
        from="/live-casino"
        to="/live-casino/discover"
      />
      <ReactRouter.Route>
        <PageNavigation header={translate('live-casino')}>
          {navigationItems.map(item => (
            <NavigationLink key={item.to} to={item.to}>
              {translate(item.label)}
            </NavigationLink>
          ))}
        </PageNavigation>
      </ReactRouter.Route>
    </ReactRouter.Switch>
  )
}

Herz.I18n.Loader.preload(
  [
    'live-casino',
    'live-casino.categories.discover',
    'live-casino.categories.roulette',
    'live-casino.categories.blackjack',
    'live-casino.categories.baccarat',
    'live-casino.categories.poker',
    'live-casino.categories.game-shows',
    'live-casino.categories.other',
  ],
  LiveCasinoNavigation
)

LiveCasinoNavigation.propTypes = {
  onUpdateCategory: PropTypes.func.isRequired,
}
